import React, { useContext, useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { AuthUserContext } from '../../provider/AuthUserContextProvider';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMLink } from '../../ui-elements/MyMLink';
import { MyMModal } from '../../ui-elements/MyMModal';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import Preview, { previewModalSize } from '../MyM906_Preview/Preview';
import { MyMImage } from '../../ui-elements/MyMImage';

/** MyMine Version12.0 TrainingLv1画面新規追加
* TrainingLv1 Page Content
*/

const TrainingPanel = (props) => {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();
  const {
    headerLabel1,
    descriptionLabel1,
    descriptionLabel2,
    descriptionLabel3,
    externalLinkUrl,
    isWindowOpen,
    onClickPreview,
    backgroundImage,
    screenId,
    panelUrl,
    additionalDescription
  } = props;

  return (
    <Box>
      <MyMLink
        underline='none'
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={() => isWindowOpen ? window.open(panelUrl) : navigate(panelUrl)}
        sx={{
          color: 'black',
          width: '100%',
          height: '100%',
          display: 'block',
          position: 'relative',
          transition: 'box-shadow 0.3s',
          cursor: 'pointer',
        }}
      >
        <Box sx={{
          position: 'relative',
          minHeight: '270px',
          height: '100%',
          borderRadius: '15px',
          overflow: 'hidden',
          border: '2px solid #BFBFBF',
          '&:hover': {
            boxShadow: '0 4px 20px 0 rgba(0,0,0,0.13)',
          }
        }}>
          <Box sx={{
            height: '100px',
            backgroundColor: '#7a7a7a',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            color: 'white',
            overflow: 'hidden',
          }}>
            {hovered && (
              <Box sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 1,
              }}>
                <Box sx={{
                  position: 'relative',
                  width: '100%',
                  height: '100%'
                }}>
                  <MyMImage
                    screenId={screenId}
                    filePath={backgroundImage}
                    sx={{
                      width: '100%',
                      height: '80%',
                      objectFit: 'cover'
                    }}
                  />
                  <Box sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(122, 122, 122, 0.8)',
                    mixBlendMode: 'multiply'
                  }} />
                </Box>
              </Box>
            )}
            <Box sx={{
              position: 'relative',
              zIndex: 2,
              padding: '10px',
              borderRadius: '5px',
            }}>
              <MyMLabel fontSize='1.4rem'>{headerLabel1}</MyMLabel>
            </Box>
          </Box>
          <Box sx={{
            textAlign: 'left',
            padding: '15px 15px 0 15px',
            backgroundColor: 'transparent',
            position: 'relative',
            zIndex: 2,
          }}>
            <MyMLabel sx={{ lineHeight: '2' }}>{descriptionLabel1 ? `${descriptionLabel1}` : ''}</MyMLabel>
            <MyMLabel sx={{ lineHeight: '2' }}>{descriptionLabel2 ? `${descriptionLabel2}` : ''}</MyMLabel>
            <MyMLabel sx={{ lineHeight: '2' }}>{descriptionLabel3 ? `${descriptionLabel3}` : ''}</MyMLabel>
            {additionalDescription && <MyMLabel sx={{ lineHeight: '2' }}>{additionalDescription}</MyMLabel>}
          </Box>
        </Box>
      </MyMLink>

      <Box sx={{ marginTop: '6px', textAlign: 'center' }}>
        <MyMLink
          underline="hover"
          onClick={(event) => {
            event.stopPropagation();
            onClickPreview();
          }}
          sx={{ fontSize: '0.9rem', textDecoration: 'underline', textDecorationColor: 'rgba(25, 118, 210, 0.4)' }}
        >
          {externalLinkUrl}
        </MyMLink>
      </Box>
    </Box>
  );
}

const TrainingSchedulePanel = (props) => {
  const navigate = useNavigate();
  const { headerLabel, url, ...other } = props;

  return (
    <MyMLink
      onClick={() => {
        if (url === 'MyM320') {
          navigate(url);
        } else {
          navigate(`${url}/${other[0]?.Process2Id ? other[0].Process2Id : '0'}`);
        }
      }}
      sx={{
        marginTop: '15px',
        textAlign: 'left',
        width: '100%',
        color: 'black',
        textDecoration: 'none',
        display: 'block',
        transition: 'box-shadow 0.3s',
        cursor: 'pointer',
      }}
    >
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        border: '#BFBFBF 3px solid',
        minHeight: '120px',
        padding: '16px',
        borderRadius: '8px',
        '&:hover': {
          boxShadow: '0 4px 20px 0 rgba(0,0,0,0.12)',
          textDecoration: 'underline',
        }
      }}>
        <MyMLabel fontSize='1.3rem' sx={{ marginBottom: '8px' }}>{headerLabel}</MyMLabel>
        {Object.keys(other).map(key => (
          <MyMLabel
            key={other[key].Process2Name}
            fontSize='0.9rem'
          >
            {other[key].Process2Name}
          </MyMLabel>
        ))}
      </Box>
    </MyMLink>
  );
}

export const TrainingLv1 = () => {
  const screenId = "MyM317";
  const { controlSettings, commonFiles } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);

  const [trainingList, setTrainingList] = useState(null);
  const [trainingScheduleList, setTrainingScheduleList] = useState(null);
  const [trainingLv3AccessList, setTrainingLv3AccessList] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  const { authUser } = useContext(AuthUserContext);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalClose = () => setIsModalOpen(false);

  /**
  * プレビュー処理
  * @param {string} fileId ファイルID
  */
  const onClickPreview = () => {
    setIsModalOpen(true);
  }

  /**
  * Contents情報取得成功時処理
  * @param {any} result
  */
  useEffect(() => {
    const callbackRequestTrainingContents = (result) => {
      setTrainingList(result.TrainingProcessList);
      setTrainingScheduleList(result.TrainingScheduleProcessList);
      setTrainingLv3AccessList(result.TrainingLv3AccessList);
      setIsLoading(false);
    }

    apiRequest.requestJson('api/training/lv1', "GET", callbackRequestTrainingContents);
  }, [])

  if (isLoading) return <MyMProgress />

  const trainingPanelData = [
    ...trainingList[0].Process2HierarchyList.slice(0, 4).map((process, index) => ({
      headerLabel1: process.Process2Name,
      panelUrl: `MyM318/${process.Process2Id}`,
      isWindowOpen: false,
      backgroundImage: index === 0 ? controlSettings.ImageList.imgSalesTechnicalTraining :
        index === 1 ? controlSettings.ImageList.imgProductSupportTraining :
          index === 2 ? controlSettings.ImageList.imgOperatiorTrainingProgram :
            controlSettings.ImageList.imgProuctTechnicalTraining,
      additionalDescription: index === 0 ? controlSettings.LabelList.lblSalesTecnicalTrainingDiscription :
        index === 1 ? controlSettings.LabelList.lblProductTecnicalTrainingDiscription :
          index === 2 ? controlSettings.LabelList.lblOperatiorTrainingProgramDiscription :
            controlSettings.LabelList.lblProductSupportTrainingDiscription,
    })),
    {
      headerLabel1: controlSettings.LabelList.lblELearingCourseHeader,
      descriptionLabel1: controlSettings.LabelList.lblELearingCourseDescription1,
      descriptionLabel2: controlSettings.LabelList.lblELearingCourseDescription2,
      descriptionLabel3: controlSettings.LabelList.lblELearingCourseDescription3,
      externalLinkUrl: controlSettings.LabelList.lnkELearingCourseTraining,
      panelUrl: controlSettings.UrlList.urlELearingCoursePage,
      isWindowOpen: true,
      onClickPreview,
      backgroundImage: controlSettings.ImageList.imgeLearingCourse,
    },
    {
      headerLabel1: trainingList[0].Process2HierarchyList[4].Process2Name,
      panelUrl: `MyM318/${trainingList[0].Process2HierarchyList[4].Process2Id}`,
      backgroundImage: controlSettings.ImageList.imgToolsandSolutionTraining,
      additionalDescription: controlSettings.LabelList.lblToolsandSolutionTrainingDiscription,
    },
    {
      headerLabel1: controlSettings.LabelList.lblInstructorsTrainingProgramHeader,
      descriptionLabel1: controlSettings.LabelList.lblInstructorsTrainingProgramDescription1,
      descriptionLabel2: controlSettings.LabelList.lblInstructorsTrainingProgramDescription2,
      descriptionLabel3: controlSettings.LabelList.lblInstructorsTrainingProgramDescription3,
      panelUrl: controlSettings.UrlList.urlInstructorsTrainingProgram,
      isWindowOpen: true,
      backgroundImage: controlSettings.ImageList.imgInstructorsTrainingProgram,
    },
  ];

  return (
    <Box className='py-1'>
      <Box>
        <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblTrainingAreaHeader}</MyMVariantLabel>
        <MyMLabel>{controlSettings.LabelList.lblTrainingAreaDescription}</MyMLabel>
      </Box>

      <Box sx={{ overflowY: 'auto', padding: '15px' }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={10}>
            <Grid container spacing={2}>
              {trainingPanelData.map((panelData, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <TrainingPanel {...panelData} onClickPreview={onClickPreview} screenId={screenId} />
                </Grid>
              ))}
            </Grid>
          </Grid>
          {trainingLv3AccessList.includes(authUser && authUser.CompanyId) &&
            <Grid item xs={12} md={12} lg={2}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px',
                marginBottom: '15px',
                borderRadius: '8px'
              }}>
                <MyMLabel fontSize='1.8rem'>{controlSettings.LabelList.lblTrainingScheduleAreaHeader}</MyMLabel>
              </Box>

              {trainingScheduleList
                .map((schedule, index) => (
                  <TrainingSchedulePanel
                    key={index}
                    headerLabel={schedule.Process1MetadataName}
                    url="MyM319"
                    {...schedule.Process2HierarchyList}
                  />
                ))}

              {trainingLv3AccessList.includes(authUser.CompanyId) && (
                <TrainingSchedulePanel
                  headerLabel={controlSettings.LabelList.lblTrainingRequestFormHeader}
                  url='MyM320'
                />
              )}
            </Grid>
          }
        </Grid>
      </Box>

      <MyMModal
        open={isModalOpen}
        onClose={handleModalClose}
        {...previewModalSize}
      >
        <Preview fileId={commonFiles.TrainingFileId} onPreviewFailed={handleModalClose} />
      </MyMModal>

    </Box>
  );
}

export default TrainingLv1;
